import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M230-106q-17 0-28-12t-12-28q0-17 12-28t28-12h500q17 0 28 12 12 12 12 28t-12 29q-11 11-28 11H230Zm250-153q-108 0-171-62t-63-169v-298q0-21 15-36 15-14 36-14t35 14q15 15 15 36v296q0 63 36 99 35 36 97 36t97-36q36-36 36-99v-296q0-21 15-36 15-14 36-14t36 14q14 15 14 36v298q0 107-63 169t-171 62Z"/>',
  f: '<path d="M230-106q-17 0-28-12t-12-28q0-17 12-28t28-12h500q17 0 28 12 12 12 12 28t-12 29q-11 11-28 11H230Zm250-153q-108 0-171-62t-63-169v-298q0-21 15-36 15-14 36-14t35 14q15 15 15 36v296q0 63 36 99 35 36 97 36t97-36q36-36 36-99v-296q0-21 15-36 15-14 36-14t36 14q14 15 14 36v298q0 107-63 169t-171 62Z"/>',
};

export default data;
